module.exports = __webpack_public_path__ + "static/media/latina.13afbb0d.png";